<template>
  <div :class="prefixCls" class="down-container" :style="{ 'background-image': `url(${downbg})` }">
    <div class="content-wrapper" :style="{ transform: `scale(${scale})`, transformOrigin: 'center center' }">
      <!-- 内容区域 -->
      <div class="down_box">
        <!-- 顶部标题 -->
        <div class="header">
          <img :src="downTitle" alt="AI随行 服务无界" class="title" />
        </div>

        <!-- 主控端/被控端按钮 -->
        <div class="button-group">
          <div :class="{
            button: true,
            'button-active': currentView === 'master',
            'button-inactive': currentView === 'controlled'
          }" @click="selectMasterView">主控端</div>
          <div :class="{
            button: true,
            'button-active': currentView === 'controlled',
            'button-inactive': currentView === 'master'
          }" @click="selectControlledView">被控端</div>
        </div>

        <!-- 下载选项和设备图片区域 -->
        <div class="download-section">
          <!-- 左侧下载选项 -->
          <div class="download-options">
            <!-- 主控端下载选项 -->
            <div v-if="currentView === 'master'" class="master-options">
              <!-- 主控端后台 -->
              <div class="app-grid">
                <div class="app-item no-hover" @click="toPage('https://admin.zhihuanai.com/')">
                  <div class="default-content">
                    <img :src="browserIcon" alt="后台" class="app-icon" />
                    <span class="app-text">浏览器后台</span>
                  </div>
                </div>
                <div class="app-item no-hover" @click="handleDown('https://down.zhihuanai.com/七鼠智服电脑(主控端).exe')">
                  <div class="default-content">
                    <img :src="windowsIcon" alt="Windows应用" class="app-icon" />
                    <span class="app-text">PC客户端</span>
                  </div>
                </div>
                <div class="app-item">
                  <div class="default-content">
                    <img :src="androidIcon" alt="Android应用" class="app-icon" />
                    <span class="app-text">安卓手机应用</span>
                  </div>
                  <div class="hover-content">
                    <img :src="qrcodeUrl.zkdAndroid" alt="Android二维码" class="qr-icon-large" />
                    <span class="app-text">Android</span>
                  </div>
                  <!-- Android 小二维码 (always visible) -->
                  <div class="qr-code qr-gray">
                    <img :src="codeGray" alt="Android二维码" class="qr-icon" />
                  </div>
                </div>
                <div class="app-item empty"></div> <!-- 新增空占位 -->
              </div>
            </div>

            <!-- 被控端下载选项 -->
            <div v-else-if="currentView === 'controlled'" class="master-options">
              <!-- Windows 和 Android 图标 -->
              <div class="app-grid app-grid-center">
                <div class="app-item no-hover" @click="handleDown('https://down.zhihuanai.com/七鼠智服电脑(被控端).zip')">
                  <div class="default-content">
                    <img :src="windowsIcon" alt="Windows应用" class="app-icon" />
                    <span class="app-text">PC客户端</span>
                  </div>
                </div>
                <div class="app-item">
                  <div class="default-content">
                    <img :src="androidIcon" alt="Android应用" class="app-icon" />
                    <span class="app-text">安卓手机应用</span>
                  </div>
                  <div class="hover-content">
                    <img :src="qrcodeUrl.bkdAndroid" alt="Android二维码" class="qr-icon-large" />
                    <span class="app-text">Android</span>
                  </div>
                  <!-- Android 小二维码 (always visible) -->
                  <div class="qr-code qr-gray">
                    <img :src="codeGray" alt="Android二维码" class="qr-icon" />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 右侧设备图片 -->
          <div class="device-image">
            <div class="image-wrapper">
              <img :src="computerImg" alt="设备展示" class="computer-img" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getPrefixCls } from '@/utils/design'

import downbg from '@/assets/img/down/pc/down_bg.png'
import downTitle from '@/assets/img/down/pc/down_title.png'
import computerImg from '@/assets/img/down/pc/computer_img.png'
import androidIcon from '@/assets/img/down/pc/android_icon.png'
import iosIcon from '@/assets/img/down/pc/ios_icon.png'
import windowsIcon from '@/assets/img/down/pc/windows_icon.png'
import browserIcon from '@/assets/img/down/pc/browser_icon.png'
import codeBlue from '@/assets/img/down/pc/code_blue.png'
import codeGray from '@/assets/img/down/pc/code_gray.png'
// 扫码二维码图片
import zkdAndroid from '@/assets/img/down/pc/zkd_android_code.png'
import iosCode from '@/assets/img/down/pc/ios_code.png'
import bkdAndroid from '@/assets/img/down/pc/bkd_android_code.png'

export default {
  name: 'Down',
  data() {
    return {
      prefixCls: getPrefixCls('down'),
      currentView: 'master', // 'master' for 主控端, 'controlled' for 被控端
      scale: 1,
      downbg,
      downTitle,
      computerImg,
      androidIcon,
      iosIcon,
      windowsIcon,
      browserIcon,
      codeBlue,
      codeGray,
      qrcodeUrl: {
        zkdAndroid: zkdAndroid,
        zkdIos: iosCode,
        bkdAndroid: bkdAndroid
      }
    }
  },
  mounted() {
    this.calculateScale()
    window.addEventListener('resize', this.calculateScale)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.calculateScale)
  },
  methods: {
    selectMasterView() {
      this.currentView = 'master'
    },
    selectControlledView() {
      this.currentView = 'controlled'
    },
    toPage(url) {
      window.open(url, '_blank')
    },
    handleDown(url) {
      const link = document.createElement('a')
      link.href = url
      link.target = '_blank'  // 在新标签页打开
      link.rel = 'noopener noreferrer'  // 安全属性
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    calculateScale() {
      const windowWidth = document.documentElement.clientWidth
      const windowHeight = document.documentElement.clientHeight
      const designWidth = 1920
      const designHeight = 1080

      // 计算宽度和高度的缩放比例
      const widthScale = windowWidth / designWidth
      const heightScale = windowHeight / designHeight

      // 取较小的缩放比例，确保内容完全显示
      let scale = Math.min(widthScale, heightScale)

      // 设置最大缩放限制，防止在2K等高分屏上过度放大
      const maxScale = 0.9
      scale = Math.min(scale, maxScale)

      this.scale = scale
    }
  }
}
</script>

<style lang="scss" scoped>
@use '@/styles/variables.scss' as *;

$prefix-cls: '#{$adminNamespace}-down';

html,
body {
  margin: 0;
  padding: 0;
  overflow: hidden;
  width: 100%;
  height: 100%;
}

.down-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  user-select: none;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  margin: 0;
  padding: 0;

  .content-wrapper {
    position: absolute;
    top: 55%;
    left: 50%;
    transform-origin: center center;
    width: 1920px;
    height: 1080px;
    margin-left: -960px;
    margin-top: -540px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .down_box {
      width: 100%;
      // width: 1280px;
      // padding: 30px 0;
      position: relative;
      z-index: 10;
      display: flex;
      flex-direction: column;
      align-items: center;
      // padding-top: 140px;

      .header {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 49px;

        .title {
          width: 529px;
        }
      }

      .button-group {
        display: flex;
        gap: 160px;
        margin-bottom: 100px;
        user-select: none;

        .button {
          // padding: 26px 123px;
          padding: 18px 94px;
          font-weight: 400;
          font-size: 24px;
          cursor: pointer;
          border-radius: 8px;
          transition: all 0.3s ease;

          &.button-active {
            background-color: #0051ff;
            color: #ffffff;
            box-shadow: 0px 4px 8px 2px rgba(0, 102, 255, 0.2);

            &:hover {
              background-color: #0047e6;
              box-shadow: 0px 6px 12px 3px rgba(0, 102, 255, 0.3);
            }
          }

          &.button-inactive {
            color: #0051ff;
            background: #ffffff;
            box-shadow: 0px 4px 8px 2px rgba(0, 102, 255, 0.2);

            &:hover {
              background-color: #f5f8ff;
              box-shadow: 0px 6px 12px 3px rgba(0, 102, 255, 0.3);
            }
          }
        }
      }

      .download-section {
        // width: 100%;
        width: 1380px;
        display: flex;
        justify-content: space-between;
        // padding: 0 127px 0 209px;

        .download-options {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          margin-bottom: 40px;
          min-height: 472px;

          .download-item {
            width: 472px;
            height: 132px;
            background: #ffffff;
            box-shadow: 0px 4px 10px 4px rgba(17, 30, 61, 0.15);
            border-radius: 16px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 76px;
            transition: all 0.3s ease;
            cursor: pointer;
            position: relative;
            overflow: hidden;

            .default-content {
              display: flex;
              align-items: center;
              transition: opacity 0.3s ease;
            }

            .icon {
              width: 88px;
              height: 88px;
              margin-right: 24px;
            }

            .text {
              font-weight: 400;
              font-size: 24px;
              color: #333333;
            }

            &:hover {
              box-shadow: 0px 8px 16px 6px rgba(17, 30, 61, 0.2);
            }
          }

          .app-grid {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 40px;
            width: 100%;

            .app-item {
              position: relative;
              width: 180px;
              height: 180px;
              background: #ffffff;
              box-shadow: 0px 4px 10px 0px rgba(17, 30, 61, 0.15);
              border-radius: 12px;
              overflow: hidden;
              transition: all 0.3s ease;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;

              &.no-hover {
                cursor: pointer;

                &:hover {
                  box-shadow: 0px 8px 16px 6px rgba(17, 30, 61, 0.2);

                  .default-content {
                    opacity: 1;
                  }
                }
              }

              .default-content {
                display: flex;
                flex-direction: column;
                align-items: center;
                transition: opacity 0.3s ease;
              }

              .hover-content {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background-color: #ffffff;
                border-radius: 16px;
                opacity: 0;
                transition: opacity 0.3s ease;
              }

              .app-icon {
                width: 88px;
                height: 88px;
              }

              .app-text {
                font-weight: 400;
                font-size: 24px;
                color: #333333;
                margin-top: 10px;
              }

              .qr-icon-large {
                width: 128px;
                height: 128px;
                margin-bottom: 8px;
              }

              // 悬停时显示的文字样式
              .hover-content .app-text {
                font-weight: 400;
                font-size: 24px;
                color: #333333;
                margin-top: 0;
              }

              .qr-code {
                position: absolute;
                top: 0;
                right: 0;
                width: 80px;
                height: 80px;
                display: flex;
                justify-content: center;
                align-items: center;
                overflow: hidden;
                transition: opacity 0.3s ease;

                &::before {
                  content: '';
                  position: absolute;
                  top: 0;
                  right: 0;
                  width: 0;
                  height: 0;
                  border-top: 80px solid transparent;
                  border-left: 80px solid transparent;
                  transform: rotate(0deg);
                }

                &.qr-blue::before {
                  border-top-color: #ddefff;
                }

                &.qr-gray::before {
                  border-top-color: #d9d9d9;
                }

                .qr-icon {
                  width: 25.6px;
                  height: 25.6px;
                  position: absolute;
                  right: 12px;
                  top: 11px;
                  z-index: 1;
                }
              }

              &:hover {
                .default-content {
                  opacity: 0;
                }

                .hover-content {
                  opacity: 1;
                }

                .qr-code {
                  opacity: 0;
                }

                box-shadow: 0px 8px 16px 6px rgba(17, 30, 61, 0.2);
              }
            }

            .app-item.empty {
              background: transparent;
              box-shadow: none;
              pointer-events: none;
            }
          }
        }

        .device-image {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;

          .image-wrapper {
            position: relative;
            transition: transform 0.3s ease;

            .computer-img {
              height: 385px;
              width: 690px;
            }

            &:hover {
              transform: scale(1.05) translateY(-10px);
            }
          }
        }
      }
    }
  }
}

.app-grid.app-grid-center {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 44px;
  width: 100%;
  min-height: 460px;
}
</style>